import { render, staticRenderFns } from "./LabelSearch.vue?vue&type=template&id=5f7fb01c&"
import script from "./LabelSearch.vue?vue&type=script&lang=ts&"
export * from "./LabelSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports